module.exports = __webpack_public_path__ + "python-icon.svg?9ecfb67266abc5a684cdce0635f4dc3c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skill-icons/python-icon.svg
// module id = 55
// module chunks = 0